/**
 * @generated SignedSource<<de9c5923aa4c8a897fae652c946ab087>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SpSiteListsProviderQuery$variables = {
  siteUrl: string;
};
export type SpSiteListsProviderQuery$data = {
  readonly getSharePointLists: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }> | null | undefined;
};
export type SpSiteListsProviderQuery = {
  response: SpSiteListsProviderQuery$data;
  variables: SpSiteListsProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteUrl"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "siteUrl",
        "variableName": "siteUrl"
      }
    ],
    "concreteType": "SharePointListItem",
    "kind": "LinkedField",
    "name": "getSharePointLists",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": "name",
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpSiteListsProviderQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpSiteListsProviderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a8f5e3f23c1496b43803b980a829f783",
    "id": null,
    "metadata": {},
    "name": "SpSiteListsProviderQuery",
    "operationKind": "query",
    "text": "query SpSiteListsProviderQuery(\n  $siteUrl: String!\n) {\n  getSharePointLists(siteUrl: $siteUrl) {\n    id\n    name: title\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9578decd17d23094d3328bb4729209a";

export default node;
